class LazyloadTemplate extends HTMLTemplateElement {
  loadContent () {
    const clone = document.importNode(this.content, true)

    this.parentElement.insertBefore(clone, this)
  }
}

export default LazyloadTemplate
